export const arrowIconProps = {
  width: 24,
  height: 24,
  alt: "",
  src: "https://images.onefootball.com/cw/icons/simple-arrow-right-light.svg",
  darkModeSrc:
    "https://images.onefootball.com/cw/icons/simple-arrow-right-dark.svg",
};
